import { reactive, ref, watch } from 'vue';

interface DialogState {
  isOpen: boolean;
  athleteTwrn: string;
}

const defaultState: DialogState = {
  isOpen: false,
  athleteTwrn: '',
};

const getDefaultState = () => ({ ...defaultState });

const state = reactive(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useAddAthleteDocumentDialog() {
  function open(athleteTwrn: string) {
    state.athleteTwrn = athleteTwrn;
    state.isOpen = true;
  }

  function close() {
    state.isOpen = false;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
    close,
  };
};
